export default {
  fonts: {
    heading: `'HK Nova', Helvetica, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"`,
    body: `'HK Nova', Helvetica, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"`,
    mono: `SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace`,
    clock: `'Digital', 'Ubuntu Mono', monospace`,
  },
  fontSizes: {
    '3xs': '0.5rem',
    '2xs': '0.625rem',
    xs: '0.75rem',
    sm: '0.875rem',
    md: '1rem',
    lg: '1.125rem',
    xl: '1.25rem',
    '2xl': '1.5rem',
    '3xl': '1.75rem',
    '4xl': '2.25rem',
    '5xl': '2.5rem',
    '6xl': '4rem',
    '7xl': '5rem',
    '8xl': '7rem',
    '9xl': '8rem',
    '10xl': '10rem',
  },
};
